import { PlatformLogo, PlatformLogoProps } from "@/components/platform/PlatformLogo";
import { useCurrentPlatform } from "@/contexts";

export type CurrentPlatformLogoProps = Omit<PlatformLogoProps, "platform">;

export const CurrentPlatformLogo = (props: CurrentPlatformLogoProps) => {
  const currentPlatform = useCurrentPlatform();
  return <PlatformLogo platform={currentPlatform} {...props} />;
};
